import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getBenefitPlanOptionsSchema = ({ planId } = {}) =>
  call(websocketFetch, 'set_benefit_plan_options/schema/request', {
    plan_id: planId,
  });
